<template>
  <b-container>
    <div>
      <p>
        Current version:
        <b-badge variant="primary">{{ $settings.version }}</b-badge>
      </p>
      <h2>Changelog</h2>
      <h3>Version 3.7</h3>
      <ul>
        <li>
          Improved chat
          <ul>
            <li>Auto detecting emojis</li>
            <li>Reply feature</li>
            <li>Minor UI tweaks</li>
            <li>Better URL detection</li>
          </ul>
        </li>
        <li>Hosts can see point statistics per round.</li>
        <li>Rank is now the first column of the score table.</li>
      </ul>
      <h3>Version 3.6</h3>
      <ul>
        <li>
          There is now a public chat that tries to catch people who want to post
          their answers.
        </li>
        <li>Minor bugfixes.</li>
      </ul>
      <h3>Version 3.5</h3>
      <ul>
        <li>Easier joining for guest teams via link.</li>
        <li>Members can leave teams.</li>
        <li>Public surveys are now visible to spectators as well.</li>
        <li>
          Hosts can now assign virgin teams per quiz by right-clicking them in
          the table.
        </li>
        <li>Changed the datepicker to prevent a bug with the native ones.</li>
      </ul>
      <h3>Version 3.4</h3>
      <ul>
        <li>Users can now see all members of their teams.</li>
        <li>Team admins can now assign other team admins.</li>
        <li>Team admins can now kick members.</li>
        <li>
          Users see a menu-indicator when a new member wants to join their team.
        </li>
      </ul>
      <h3>Version 3.3</h3>
      <ul>
        <li>Fixed missing scores on score buttons.</li>
        <li>Fixed teams not being sorted alphabetically.</li>
      </ul>
      <h3>Version 3.2</h3>
      <ul>
        <li>
          Hosts can now set survey answers for teams that did not submit an
          answer.
        </li>
      </ul>
      <h3>Version 3.1</h3>
      <ul>
        <li>Hosts can now add surveys to quizzes.</li>
      </ul>
    </div>
  </b-container>
</template>

<script>
export default {
  name: "Changes",
  components: {}
};
</script>
